import { LogFirebase } from "../../../../../services/firestore";
import { CALL_DATA, GLOBAL_MEETING_DATA } from "../../../../../constants/PublicVariables";
import { setRemoteParticipanteAudioVideoStatus } from "../../../Room/roomFunction";

export const trackEnabledInRoomEvent = (track, participant) => {
    if (track) {
        LogFirebase("TwilioEvents", "trackEnabledInRoom", {
            track_details: track.kind,
            identity: participant.identity,
        });
        if (GLOBAL_MEETING_DATA.ucid) {
            if (participant.identity != CALL_DATA.localIdentity) {
                if (track.kind == "audio") {
                    setRemoteParticipanteAudioVideoStatus("audio", participant.identity, track.isTrackEnabled);
                }
                if (track.kind == "video") {
                    const str = track.trackName;
                    const fristLtr = str.charAt(0);
                    if (fristLtr != "s") {
                        setRemoteParticipanteAudioVideoStatus("video", participant.identity, track.isTrackEnabled);
                    } else {
                        setRemoteParticipanteAudioVideoStatus("video", participant.identity, false);
                    }
                }
            }
        }
    }
};
